import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { setIndex } from "../dailyTradeUXSlice";
import { PageIndex } from "../../../models";

export const useDailyTradesReportIndex = () => {
  const pageIndex = useSelector<StoreType, PageIndex>(
    (s) => s.ux.reports.dailyTrade.index
  );

  const dispatch = useDispatch();
  const dispatchSetIndex = React.useCallback(
    (index: PageIndex) => dispatch(setIndex(index)),
    [dispatch]
  );

  return [pageIndex, dispatchSetIndex] as [
    typeof pageIndex,
    typeof dispatchSetIndex
  ];
};
